import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkNormalizeTypography from '@/lib/typography/remarkNormalizeTypography.js';

const REMARK_PLUGINS = [remarkGfm, remarkNormalizeTypography];

const MARKDOWN_COMPONENTS = {
  a: ({ node: _node, children, ...props }) => (
    <a {...props} target="_blank" rel="noreferrer noopener">
      {children}
    </a>
  ),
  table: ({ node: _node, ...props }) => (
    <div className="comp-markdown-text__table">
      <table {...props} />
    </div>
  )
};

/** Text written in Markdown, such as a reply from Pieve or a run result. Links open in a new tab; wide tables scroll on their own. Curly quotes and long dashes the model
   wrote show as plain ASCII (normalizeTypography). */
const MarkdownText = ({ text }) => {
  return (
    <div className="comp-markdown-text">
      <Markdown remarkPlugins={REMARK_PLUGINS} components={MARKDOWN_COMPONENTS}>
        {text}
      </Markdown>
    </div>
  );
};

export default MarkdownText;
